// Entry point for the build script in your package.json
import "./bugsnag"

import "./appsignal"

// Rails UJS
import Rails from '@rails/ujs'
Rails.start()

import "./no-focus-outline"
import "./ui"
import "./tooltips"
